/* eslint-disable no-console */
import { put, takeEvery, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
  setUserJobPost as setUserJobPostRequest,
  changeUserJobPost,
  deleteUserJobPost as deleteUserJobPostRequest,
  setRecruiterJobPost as setRecruiterJobPostRequest,
  deleteRecruiterJobPost as deleteRecruiterJobPostRequest,
  getUserJobPosts,
  getAllJobPosts as getAllJobPostsRequest,
} from 'api/jobPosts';
import setLoading from 'actions/loading';
import { getDashBoardStatistics } from 'modules/DashBoard/actions';
import { ACTIVE } from 'constants/index';
import {
  startCreateJobPostSubmit,
  resolveCreateJobPostSubmit,
  setJobPost,
  deleteJobPost,
  publishJobPost,
  deleteRecruiterJobPost,
  setUserJobPosts,
  setAllJobPosts,
  getAllJobPosts,
  setJobPostsLoading,
  saveRecruiterJobPost,
} from './actions';

export function* refetchUserJobPosts(role: string, token: string) {
  const jobPosts = yield getUserJobPosts(role, token);
  if (jobPosts) {
    yield put(setUserJobPosts(jobPosts.data.jobs));
  }
}

export function* refetchAllJobPosts(token: string) {
  const jobPosts = yield getAllJobPostsRequest(
    token,
    JSON.stringify({ order: ['createdAt DESC'] })
  );
  if (jobPosts) {
    yield put(setAllJobPosts(jobPosts.data.jobs));
  }
}

function* getAllJobPostsSaga({ payload }: { payload: string }) {
  yield put(setJobPostsLoading(true));
  const { token } = yield select(state => state.user);

  try {
    const { data } = yield getAllJobPostsRequest(token, payload);
    yield put(setAllJobPosts(data.jobs));
  } catch (error) {
    console.log(error);
  }
  yield put(setJobPostsLoading(false));
}

export function* createJobPostSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  const { jobPostId, status } = action.payload;

  const jobPostData = {
    title: action.payload.title,
    type: action.payload.type,
    requirements: action.payload.requirements,
    responsibilities: action.payload.responsibilities,
    info: action.payload.info,
    salary: { min: action.payload.minSalary, max: action.payload.maxSalary },
    skills: [action.payload.firstSkill, action.payload.secondSkill, action.payload.thirdSkill],
    interviewsCount: Number(action.payload.interviewsCount),
    isRequireRecruiter: action.payload.isRequireRecruiter.toLowerCase() === 'yes',
    linkToTest: action.payload.linkToTest ? action.payload.linkToTest : '',
    currency: action.payload.currency,
    compensationAsRate: action.payload.compensationType === 'Percentage',
    compensation: Number(action.payload.compensation),
    country: action.payload.country,
    state: action.payload.state,
    city: action.payload.city,
  };

  try {
    if (jobPostId) {
      yield changeUserJobPost(jobPostData, jobPostId, token);
      yield put(resolveCreateJobPostSubmit());

      const jobPosts = yield getUserJobPosts(role, token);
      yield put(setUserJobPosts(jobPosts.data.jobs));

      if (status === ACTIVE) {
        yield put(push(`/job-post-details/${jobPostId}`));
      } else {
        yield put(push(`/job-post-preview/${jobPostId}`));
      }
    } else {
      const jobPost = yield setUserJobPostRequest(jobPostData, token);
      yield put(resolveCreateJobPostSubmit());

      yield put(setJobPost(jobPost.data));
      if (status === ACTIVE) {
        yield put(push(`/job-post-details/${jobPost.data.id}`));
      } else {
        yield put(push(`/job-post-preview/${jobPost.data.id}`));
      }
    }
  } catch (error) {
    yield put(resolveCreateJobPostSubmit(error.response));
  }
}

export function* publishJobPostSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  try {
    yield put(setLoading(true));
    yield changeUserJobPost({ status: action.payload.status }, action.payload.jobPostId, token);
    yield put(setLoading(false));

    const jobPosts = yield getUserJobPosts(role, token);
    yield put(setUserJobPosts(jobPosts.data.jobs));
    yield put(getDashBoardStatistics());
    yield put(push('/job-posts'));
  } catch (error) {
    yield put(setLoading(false));
    console.log(error.response);
  }
}

export function* deleteJobPostSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  try {
    yield put(setLoading(true));
    yield deleteUserJobPostRequest(action.payload, token);

    const jobPosts = yield getUserJobPosts(role, token);

    yield put(setLoading(false));

    yield put(push('/job-posts'));

    yield put(setUserJobPosts(jobPosts.data.jobs));
  } catch (error) {
    yield put(setLoading(true));
    console.log(error.response);
  }
}

export function* saveRecruiterJobPostSaga(action: any) {
  const { token } = yield select(state => state.user);
  const { jobPostId } = action.payload;
  try {
    yield put(setLoading(true));

    yield setRecruiterJobPostRequest(jobPostId, token);

    yield put(setLoading(false));
    yield put(getDashBoardStatistics());
  } catch (error) {
    console.error(error.response);
  }
}

export function* deleteRecruiterJobPostSaga(action: any) {
  const { token } = yield select(state => state.user);
  const { jobPostId } = action.payload;
  try {
    yield put(setLoading(true));

    yield deleteRecruiterJobPostRequest(jobPostId, token);

    yield put(setLoading(false));

    yield put(getDashBoardStatistics());
  } catch (error) {
    console.error(error.response);
  }
}

export default function* createJobPostSagas() {
  yield takeEvery(startCreateJobPostSubmit, createJobPostSaga);
  yield takeEvery(publishJobPost, publishJobPostSaga);
  yield takeEvery(deleteJobPost, deleteJobPostSaga);
  yield takeEvery(saveRecruiterJobPost, saveRecruiterJobPostSaga);
  yield takeEvery(deleteRecruiterJobPost, deleteRecruiterJobPostSaga);
  yield takeEvery(getAllJobPosts, getAllJobPostsSaga);
}
